<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .actions {
    display: flex;
    gap: utils.in_rem(6px);
  }
</style>

<script>
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import { showToast, ToastError } from "@sourcewhale/core";
  import { getDownloadUrl } from "../../../../api/files";

  let { row, deleteCallback, skeleton = false } = $props();

  const disabled = $derived(skeleton);

  const downloadFile = async (fileId) => {
    try {
      const { url } = await getDownloadUrl(fileId);
      window.open(url, "_blank");
    } catch (err) {
      if (err instanceof ToastError) {
        err.title = "Failed to download file";
        showToast(err);
        return;
      }
      throw err;
    }
  };

  const handleDelete = async (fileId) => {
    if (!deleteCallback) return;
    await deleteCallback(fileId);

    showToast({
      title: "Success",
      subtitle: "File deleted successfully.",
      type: "success",
    });
  };
</script>

<div class="actions">
  <ButtonWithTooltip
    kind="tertiary-blue"
    size="small"
    class={disabled ? "disabled" : ""}
    {disabled}
    leadingIcon="fa-regular fa-download"
    onclick={() => {
      downloadFile(row.fileId, row.filename);
    }}
    aria-label="Download file"
  >
    <span slot="tooltip"> Download file </span>
  </ButtonWithTooltip>
  <ButtonWithTooltip
    kind="destructive"
    size="small"
    class={disabled ? "disabled" : ""}
    {disabled}
    leadingIcon="fa-regular fa-trash-can"
    onclick={() => handleDelete(row.fileId)}
    aria-label="Delete file"
  >
    <span slot="tooltip"> Delete file </span>
  </ButtonWithTooltip>
</div>
